<template>
    <div class="upload_box">
        <el-upload
            action=""
            :http-request="uploadFile"
            class="upload_up"
            multiple
            :show-file-list="false"
        >
            <el-button
                class="iconfont upload_btn iconfont iconshangchuan1"
                size="small"
                type="primary"
            ></el-button>
        </el-upload>
    </div>
</template>

<script>
export default {
    name: 'uploading',
    data() {
        return {
            file: '',
            filename: '',
            fileUrl: '',
        };
    },
    props: {
        // 数据id
        businessid: {
            type: [Array, Object, String, Number],
        },
        // 业务类型编码
        buCode: {
            type: [Array, Object, String, Number],
        },
        // 父id
        parentid: {
            type: [Array, Object, String, Number],
        },
        // 操作项
        currData: {
            type: [Array, Object, String, Number],
        },
        // 菜单路径数据
        fileHierarchy: {
            type: [Array, Object, String, Number],
        },
    },
    methods: {
        // 普通文件上传
        uploadFile(e) {
            const tenantId = this.$takeTokenParameters('TenantId');
            this.file = e.file;
            this.filename = this.file.name;

            const formData = new FormData();
            formData.append('FileType', 0);
            formData.append('BusinessTypeCode', this.buCode || 'Flow');
            formData.append('DataId', this.businessid || '');
            formData.append('DirectoryId', this.parentid || '');
            formData.append('TenantId', tenantId);
            formData.append('File', this.file);

            const url = `${this.FILE.FILE_BASE_URL()}file-manage?__tenant=${tenantId}`;
            this.$axios.post(url, formData)
                .then(res => {
                    if (res && res.Id) {
                        this.$emit('uploadFirm', res.Id, this.file, 2);
                    }
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode ? error.ErrorCode.Message : '上传失败');
                });
        },
    },
};
</script>

<style scoped lang="stylus">
    .upload_box{
        width: 50px;
        margin: 0 0 0 -22px;
        font-size: 14px;
        font-weight: 800;
    }
    .upload_up{}
    .upload_btn {
        color: #000;
        font-size: 14px;
    }
</style>
